import React from 'react';
import PropTypes from 'prop-types';

export const TblList = ({ children }) => {
  return (
    <div className="article-wrap">
      <div className="tbl-list">
        <div className="tbl-body thead-lg">
          <div className="tbl-row">{children}</div>
        </div>
      </div>
    </div>
  );
};

TblList.propTypes = {
  children: PropTypes.node,
};
TblList.defaultProps = {
  children: null,
};
export default TblList;
